/* eslint-disable consistent-return */
import styled, { keyframes } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import {
  mr, mb, p, ml, mt, mx
} from 'styled-components-spacing';

import theme from '@theme';

export const { borderRadius, shadows } = theme;

export const StyledCover = styled.div`
  max-width: 1400px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
    max-width:800px;
  `}
  @media (min-width:1024px) and (max-width:1245px){
    max-width:1000px;
  }
`;

export const StyledSubHeading = styled.div`
  color:#848687;
  font-size: 25px;
  font-weight: 600;
  text-align: center;
  padding-bottom: 1.5rem;
  ${breakpoint('mobile', 'desktop')`
    font-size: 15px;
  `}

`;

export const StyledFlowButtonWrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
  @media (max-width:500px){
    max-width:329px;
    margin: auto;
  }
  @media (min-width:500px) and (max-width:737px){
    max-width:490px;
    margin: auto;
  }
`;

export const StyledFlowButtonContainer = styled.a`
  ${mb(5)}
  ${p(3)}
  ${ml(2)}
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  height: 104px;
  width: 110px;
  ${props => props.seemore && `
    justify-content: center;
    height: auto
    margin-bottom: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
    ${p(0)}
    ${ml(0)}
    width: 100px;
    margin-bottom: 2.5rem;
    height: 100px;
     ${props => props.seemore && `
      height: auto;
      ${mb(0)}
        `}
  `}

 ${breakpoint('tablet', 'desktop')`
    ${ml(1)}
    ${mr(1)}
    ${mb(0)}
    height: auto;
    width: ${props => (props.seemore ? 'auto' : '100px')};
    flex-direction: column;
  `}
  @media (min-width:500px) and (max-width:737px){
    width:140px;
  }
  &:hover{
    color: #3EC6E3;
  }
`;

const shake = keyframes`
  10% {
    transform: translate3d(0px, 0, 0);
  }
  100% {
    transform: translate3d(4px, 0, 0);
  }
`;

export const StyledFlowButton = styled.button`
  border-radius: 50%;
  border: 2px solid #EAEAEB;
  /* ${shadows.mediumStrong} */
  align-items: center;
  background: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  outline: none;
  background-color: ${theme.colors.white};
  ${breakpoint('mobile', 'tablet')`
    ${mr(0)}
    ${mb(0)}
    height: 75px;
    width: 75px;
     border: 1.5px solid #EAEAEB;
  `}
  @media (min-width:500px) and (max-width:737px){
    height: 65px;
    width: 65px;
  }

  ${breakpoint('tablet', 'desktop')`
    ${mr(0)}
    ${mb(0)}
    height: 100px;
    width: 100px;
  `}

   &:hover{
    animation: ${shake} 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    perspective: 1000px;
    box-shadow: 
          0 3px 8px rgba(0 0 0/ 0.2), /* Top shadow */
          0 -3px 8px rgba(0 0 0/ 0.2), /* Bottom shadow */
          3px 0 8px rgba(0 0 0/ 0.2), /* Right shadow */
          -3px 0 8px rgba(0 0 0/ 0.2); 
  }
 
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  height: 80px;
  width: 80px;
  ${p(2)}
  ${mb(3)}
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  >svg {
    width: 69px;
    height: 79px;
    stroke:#3EC6E3;
    > path {
      stroke: #3EC6E3;
      background-color: black !important;
    }
  }
  ${breakpoint('desktop')`
    width: 90px;
    height: 90px;
  `}

${breakpoint('mobile', 'tablet')`
    height: 70px;
    width: 70px;
    >svg{ 
      width: 45px;
      height: 45px;
    }
    margin:0rem;
`}
  @media (min-width:500px) and ( max-width:737px){
     svg{
      width:50px;
      height:50px;
     }
     height:60px;
     width:60px;
  }

  ${breakpoint('tablet', 'desktop')`
    height: 60px;
    width: 60px;
    >svg{ 
      width: 54px;
      height: 54px;
    }
    margin-bottom:0rem;
`}
`;

export const StyledLabel = styled.div`
  width: 120%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  line-height: 1.57;
  text-decoration :${props => (props.underline ? 'underline' : 'none')};
  color: ${props => (props.underline ? '#3EC6E3' : 'black')};
  font-weight: 600;
  ${breakpoint('mobile', 'tablet')` 
    font-weight: 600;
    margin-top: 15px;
    text-decoration :${props => (props.underline ? 'underline' : 'none')};
    color:${props => (props.underline ? '#3EC6E3' : '')};
    ${props =>
    props.seemore
      && `
      text-decoration: underline;
     border: 2px solid white;
     margin-top: 0px;
     width: 100px;
     padding: 5px;
     border-radius: 8px;
     cursor: pointer;
      font-size: 15px !important;
    `}
    font-size: 15px;
    line-height: 1.2;
  `}
  &:hover{
    color: #3EC6E3;
  }

  ${breakpoint('tablet')`
    flex: 0 0 auto;
    ${mt(3)}
    font-size:${props => (props.seemore ? '20px' : '15px')};
    margin-top :${props => (props.seemore ? '1rem' : '')} 
  `}
`;

export const StyledHeading = styled.div`
  font-size: 30px;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  color:#136C9D;
  ${mt(5)};
  ${mb(4)}
  ${breakpoint('mobile', 'tablet')`
    font-size: 25px;
    ${mt(4)};
    ${mb(3)}
    ${mx(3)}
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 29px;
  `}
`;
